import { InteractionType, type PopupRequest } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import type { ReactNode } from "react";
import { LoadingScreen } from "src/components/LoadingScreen";

interface AuthenticationWrapperProps {
    children: ReactNode;
    loginRequest: PopupRequest;
}

/**
 * Applies MSAL redirect authentication for the main SPA.
 * Widget and copilot routes skip this wrapper — they use their own auth providers.
 * Playwright builds replace this module with a passthrough stub.
 */
export function AuthenticationWrapper({ children, loginRequest }: AuthenticationWrapperProps) {
    const isWidgetRoute = window.location.hash.includes("/widget/");
    const isCopilotRoute =
        window.location.hash.includes("/copilot") ||
        window.location.search.includes("mode=copilot");

    if (isWidgetRoute || isCopilotRoute) {
        return <>{children}</>;
    }

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
            loadingComponent={LoadingScreen}
        >
            {children}
        </MsalAuthenticationTemplate>
    );
}
